module.exports = __webpack_public_path__ + "img/logoArgusBlanco.6e3c4241.png";